import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMPData } from 'src/mentor/services'

export const getTeacherClinicAssociations = createAsyncThunk(
  'teacher/getTeacherClinicAssociations',
  async (_, { rejectWithValue, fulfillWithValue, getState }) => {
    getTeacherClinicAssociations.pending()
    const { teacherProfileDataStore } = getState()
    const associatedClinics = teacherProfileDataStore?.associatedClinics?.data

    if (Array.isArray(associatedClinics) && associatedClinics.length > 0) {
      return fulfillWithValue(associatedClinics)
    }

    const resp = await getMPData('/api/secure/teacher/clinic-profile')
    if (resp?.status === 200) {
      return fulfillWithValue(resp?.data)
    } else {
      rejectWithValue(resp.message)
    }
  },
)
